(function () {
  'use strict';

  // Four independent gates:
  //   SUBSCRIBED_KEY (localStorage)   — permanent stop once the visitor submits.
  //   SHOWN_COUNT_KEY (localStorage)  — total lifetime opens; capped at MAX_SHOWS.
  //   SESSION_SEEN_KEY (sessionStorage) — once per browser session.
  //   DISMISSED_AT_KEY (localStorage) — timestamp of last user-dismissal;
  //     suppresses the popup for DISMISS_COOLDOWN_MS after close/"No thanks".
  var SUBSCRIBED_KEY      = 'hvac_nl_subscribed';
  var SHOWN_COUNT_KEY     = 'hvac_nl_shown_count';
  var SESSION_SEEN_KEY    = 'hvac_nl_session_seen';
  var DISMISSED_AT_KEY    = 'hvacmore_newsletter_popup_dismissed_at';
  var MAX_SHOWS = 3;
  var DISMISS_COOLDOWN_MS = 12 * 60 * 60 * 1000;
  var GHOST_CLICK_GUARD_MS = 400;

  function init() {
    var overlay = document.getElementById('hvac-nl-overlay');
    console.log('[hvac-nl] init called, overlay in DOM:', !!overlay);
    if (!overlay) return;

    // Skip popup entirely in automated browsers (Lighthouse, Selenium, etc.)
    if (navigator.webdriver) { console.log('[hvac-nl] blocked: webdriver'); return; }

    // Prevent double-init on the exact same element (happens when both the
    // deferred script and shopify:section:load fire on the initial editor load).
    // The flag is on the element so it resets automatically when Shopify
    // replaces the section DOM after a setting change.
    if (overlay.dataset.hvacInit) { console.log('[hvac-nl] blocked: already initialized'); return; }
    overlay.dataset.hvacInit = '1';

    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    var forceShow = inEditor || window.location.search.indexOf('newsletter=preview') !== -1;
    var stayOpen = overlay.dataset.stay === 'true';

    var DELAY_MS = parseInt(overlay.dataset.delay, 10);
    if (isNaN(DELAY_MS)) DELAY_MS = 60000;
    var MIN_LIVE_DELAY_MS = 60000;

    var subscribed = false;
    var seenThisSession = false;
    var shownCount = 0;
    var dismissedAt = 0;
    if (!forceShow) {
      try { subscribed = localStorage.getItem(SUBSCRIBED_KEY); } catch (e) {}
      try { seenThisSession = sessionStorage.getItem(SESSION_SEEN_KEY); } catch (e) {}
      try { shownCount = parseInt(localStorage.getItem(SHOWN_COUNT_KEY), 10) || 0; } catch (e) {}
      try { dismissedAt = parseInt(localStorage.getItem(DISMISSED_AT_KEY), 10) || 0; } catch (e) {}
    }

    // 12-hour cooldown after user-dismissal (X or "No, thank you").
    var withinDismissCooldown = dismissedAt > 0 && (Date.now() - dismissedAt) < DISMISS_COOLDOWN_MS;

    // Never show again once the visitor has subscribed.
    // Never show again once the lifetime cap (MAX_SHOWS) is reached.
    // Suppress for 12h after the visitor dismissed the popup.
    // Show at most once per browser session otherwise.
    // forceShow (editor / ?newsletter=preview) bypasses all gates.
    console.log('[hvac-nl] gates:', { subscribed: !!subscribed, seenThisSession: !!seenThisSession, shownCount: shownCount, withinDismissCooldown: withinDismissCooldown, forceShow: forceShow });
    if (!forceShow && (subscribed || seenThisSession || shownCount >= MAX_SHOWS || withinDismissCooldown)) { console.log('[hvac-nl] blocked by gate — popup will NOT open'); return; }

    function markSessionSeen() {
      if (forceShow) return;
      try { sessionStorage.setItem(SESSION_SEEN_KEY, '1'); } catch (e) {}
      try {
        var next = (parseInt(localStorage.getItem(SHOWN_COUNT_KEY), 10) || 0) + 1;
        localStorage.setItem(SHOWN_COUNT_KEY, String(next));
      } catch (e) {}
    }

    function markSubscribed() {
      if (forceShow) return;
      try { localStorage.setItem(SUBSCRIBED_KEY, '1'); } catch (e) {}
      markSessionSeen();
    }

    // forceShow (editor/preview) → short cosmetic delay so the popup is
    //   visible immediately in the theme editor.
    // Live site → hard floor of MIN_LIVE_DELAY_MS (60s). Client requirement is
    //   a 1-minute wait; the admin range setting can push it longer but never
    //   shorter. `stay_open` only controls the post-open enforcement layer.
    var delay = forceShow ? 500 : Math.max(DELAY_MS, MIN_LIVE_DELAY_MS);

    var userClosed = false;
    var observer = null;
    var keepOpenInterval = null;
    var openedAt = 0;

    function canClose() {
      return Date.now() - openedAt >= GHOST_CLICK_GUARD_MS;
    }

    // enforceOpen — called by the MutationObserver and the interval.
    // Restores both the CSS classes and the inline !important styles so that
    // even if external code removes the class OR overrides the style, the
    // overlay snaps back visible within 200 ms at most.
    function enforceOpen() {
      if (userClosed) return;
      if (!overlay.classList.contains('hvac-nl--open'))   overlay.classList.add('hvac-nl--open');
      if (!overlay.classList.contains('hvac-nl--pinned')) overlay.classList.add('hvac-nl--pinned');
      overlay.style.setProperty('opacity',        '1',       'important');
      overlay.style.setProperty('visibility',     'visible', 'important');
      overlay.style.setProperty('pointer-events', 'auto',    'important');
      document.body.style.overflow = 'hidden';
    }

    function openPopup() {
      overlay.querySelectorAll('img[data-src]').forEach(function(img) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      });
      openedAt = Date.now();
      // Mark the session-seen flag the moment the popup is actually shown.
      // If the visitor navigates to another page without interacting, the
      // popup won't re-open until they start a new browser session.
      markSessionSeen();

      if (stayOpen) {
        // Layer 1 – MutationObserver: reacts the instant the class attribute
        // is touched (watches class only to avoid an observer feedback loop).
        if (window.MutationObserver) {
          observer = new MutationObserver(enforceOpen);
          observer.observe(overlay, { attributes: true, attributeFilter: ['class'] });
        }

        // Layer 2 – interval: catches anything the observer misses, including
        // inline-style overrides (checked every 200 ms).
        keepOpenInterval = setInterval(enforceOpen, 200);

        // Layer 3 – page-lifecycle events: re-enforce after tab switches,
        // bfcache restores, or any visibility change.
        document.addEventListener('visibilitychange', enforceOpen);
        window.addEventListener('pageshow', enforceOpen);

        // Apply all three layers immediately.
        enforceOpen();
      } else {
        overlay.classList.add('hvac-nl--open');
        document.body.style.overflow = 'hidden';
      }
    }

    function closePopup() {
      if (!canClose()) return;
      userClosed = true;

      // Persist the dismissal timestamp so the 12-hour cooldown survives
      // refreshes and navigation. Skipped in editor/preview so previewing
      // dismissal doesn't lock the popup out for real visitors on that browser.
      if (!forceShow) {
        try { localStorage.setItem(DISMISSED_AT_KEY, String(Date.now())); } catch (e) {}
      }

      // Tear down all enforcement.
      if (observer)          { observer.disconnect(); observer = null; }
      if (keepOpenInterval)  { clearInterval(keepOpenInterval); keepOpenInterval = null; }
      document.removeEventListener('visibilitychange', enforceOpen);
      window.removeEventListener('pageshow', enforceOpen);

      // Remove inline !important overrides before removing classes so the
      // CSS transition (opacity fade) plays correctly.
      overlay.style.removeProperty('opacity');
      overlay.style.removeProperty('visibility');
      overlay.style.removeProperty('pointer-events');
      overlay.classList.remove('hvac-nl--pinned');
      overlay.classList.remove('hvac-nl--open');
      document.body.style.overflow = '';
    }

    console.log('[hvac-nl] scheduling openPopup in', delay, 'ms (dataset.delay was', overlay.dataset.delay, ')');
    setTimeout(function () {
      console.log('[hvac-nl] timer fired — calling openPopup now');
      openPopup();
    }, delay);

    // Prevent backdrop clicks from bubbling to body-level handlers.
    overlay.addEventListener('click', function (e) { e.stopPropagation(); });

    // Close (✕) and dismiss ("No, thank you") only close for this session.
    // The visitor will see the popup again on their next browser session
    // unless they subscribed via the form.
    var closeBtn = overlay.querySelector('.hvac-nl-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        if (e.isTrusted) closePopup();
      });
    }

    var dismissBtn = overlay.querySelector('.hvac-nl-dismiss');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function (e) {
        if (e.isTrusted) closePopup();
      });
    }

    var form = document.getElementById('hvac-nl-form');
    if (form) {
      // Belt-and-suspenders: also set target from JS in case the Liquid
      // {% form %} tag on this theme version doesn't pass it through.
      form.setAttribute('target', 'hvac-nl-sink');

      // Native submit into the hidden iframe — the same path Shopify's own
      // footer newsletter uses, so /contact will always accept it. We don't
      // preventDefault; the browser submits the form normally.
      form.addEventListener('submit', function () {
        var email = document.getElementById('hvac-nl-email').value.trim();
        if (!email) return;

        form.style.display = 'none';
        var success = overlay.querySelector('.hvac-nl-success');
        if (success) success.style.display = 'block';
        // Permanent stop — the visitor has subscribed, don't show again ever.
        markSubscribed();
      });
    }
  }

  // shopify:section:load fires both on initial editor load and after every
  // setting change.  The data-hvac-init flag on the overlay element prevents
  // double-init when the deferred script and this event both fire for the same
  // element; Shopify's DOM replacement after a setting change gives us a fresh
  // element (no flag), so re-init always works correctly.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('#hvac-nl-overlay')) {
      init();
    }
  });

  // Also run on normal page load (live site has no shopify:section:load).
  // In the editor, if shopify:section:load already ran first and set the flag,
  // this becomes a no-op.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
